import { Customer } from './customer';
import { Assignment } from './assignment';
import { InvoiceLine } from './invoice-line';
import { ResolvedBreadcrumb } from './resolved-breadcrumb';

export class Invoice implements ResolvedBreadcrumb
{
	id: number;
	customer_id: number;
	financial_debit_id: number;
	customer: Customer;
	assignment_id: number;
	assignment: Assignment;
	number: string;
	invoice_date: string;
	send_at: string;
	created_at: string;
	invoiceLines: InvoiceLine[];

	getBreadcrumb()
	{
		return this.number;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/invoice.ts